import React from 'react';
import { Box } from '@mui/material';

interface SectionWrapperProps {
  children: any;
}

export const SectionWrapper = ({
  children,
}: SectionWrapperProps) => {
  return (
    <Box sx={{
      display: 'flex',
      flexDirection: 'column',
      flex: 1,
      width: '100%',
    }}>
      <Box sx={{
        margin: '32px 0',
      }}>
        {children}
      </Box>
    </Box>
  );
};
